export const accountFr = {
    informationsTitle: 'Informations',
    rolesTitle: 'Rôles',
    changePasswordTitle: 'Changer de mot de passe',
    twoFATitle: 'Authentification à deux facteurs',

    model: {
        name: 'Nom',
        email: 'Email',
        roles: 'Rôles',
        password: 'Mot de passe',
        confirmPassword: 'Confirmer le mot de passe',
        currentPassword: 'Mot de passe actuel'
    },

    twoFa: {
        twoFaActivated:
            "Authentification à deux facteurs activé. Confirmez avec votre application d'authentification.",
        selectMode:
            'Vous pouvez créer un authenticator sur votre application soit en scannant le QR Code, soit en entrant le code secret manuellement.',
        secretCode: 'Code secret',
        enable2FaAction: 'Activer le 2FA',
        disable2FaAction: 'Désactiver le 2FA',
        twoFaEnterCode:
            "Entrer le code affiché sur votre authenticator afin de confirmer l'activation de la 2FA.",
        authCode: 'Code authenticator',
        twoFAEnabledtitle: '2FA activé'
    }
}
